export default __webpack_public_path__ + "static/media/online-menu.5a00e5cd.svg";